module.exports = __webpack_public_path__ + "img/yumna-150px.a0d7ff3c.png";